import { Badge, Breadcrumb, Button, Card, Table, Tag, Tooltip } from "antd"
import { Link } from "react-router-dom"
import { useFetch } from "../hooks/useFetch"
import tarjeta from "../assets/tarjeta.jpg"

export const ProductTypes = () => {

    const { data } = useFetch(`${process.env.REACT_APP_API}/productsClient`, {}, []);

    const { data: requestData, isLoading } = useFetch(`${process.env.REACT_APP_API}/clientRequest`, {}, []);

    const columns = [
        {
            title: 'Producto',
            dataIndex: 'productName',
            key: 'productName',
        },
        {
            title: 'Cantidad',
            dataIndex: 'investment',
            key: 'investment',
            render: (investment) => {
                return <p>{investment}€</p>
            }
        },
        {
            title: 'Estado',
            key: 'statusDescription',
            dataIndex: 'statusDescription',
            align: 'center',
            render: (statusDescription) => {

                return (
                    <Tag>{statusDescription}</Tag>
                )
            }
        }
    ]

    return (

        <div className="general-container">
           
            <h2 style={{ textAlign: 'center', marginBottom: '20px', color:'var(--header-grey)' }}>Servicios de compra</h2>  
            {data &&
                data.map((product) => (
                    product?.titleOffers?.length > 0 ? (
                        <Badge.Ribbon
                            key={product.id}                            
                            text={<Tooltip title={product.titleOffers.join(' , ')}><p><b>¡OFERTA!</b></p></Tooltip>}
                            color="var(--accent-variant)"                                               
                        >
                            <Card size='small' key={product.id} style={{ margin: '10px 0px', background:'ivory', borderTop: '3px solid var(--accent-variant)', paddingTop: '10px' }}>

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                    <img src={tarjeta} style={{ width: '140px', borderRadius:'5px' }} />
                                    <div style={{ padding: '20px' }}>
                                        <h3 style={{ fontWeight: 500, fontStyle: 'italic', marginBottom: '5px', color:'var(--dark-accent)' }}>{product.name}</h3>
                                        <Button size="small" style={{ backgrounbd:'white', color: 'var(--dark-accent)', borderColor: 'var(--dark-accent)' }}><Link to={`/contratos/tipos/${product.name}/${product.id}`}><b>Contactar</b></Link></Button>                                        
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <a style={{ fontWeight: 500, fontStyle: 'italic' }} target="blank" href={product.url}>Ver Info</a>
                                </div>
                            </Card>
                        </Badge.Ribbon>
                    ) : (
                        <Card size='small' key={product.id} style={{ margin: '10px 0px', borderTop: '3px solid var(--accent-variant)', paddingTop: '10px' }}>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '0.5px solid lightgray', }}>

                                <img src={tarjeta} style={{ width: '140px' }} />
                                <div style={{ padding: '20px' }}>
                                    <h2 style={{ fontWeight: 500, fontStyle: 'italic', marginBottom: '5px' }}>{product.name}</h2>
                                    <Button style={{ color: 'var(--dark-accent)', borderColor: 'var(--dark-accent)' }}><Link to={`/contratos/tipos/${product.name}/${product.id}`}>Contactar</Link></Button>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <a style={{ fontWeight: 500, fontStyle: 'italic' }} target="blank" href={product.url}>Ver Info</a>
                            </div>
                        </Card>
                    )
                ))}

            <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <h3 style={{ color:'var(--header-grey)' }}>Mis solicitudes</h3>
                <Table
                    size="small"
                    dataSource={requestData}
                    columns={columns}
                    loading={isLoading}
                />
            </div>

        </ div>
    )
}